<template>
    <div class="time-select">
        <div class="header">
            <label>{{ $t("wp.whenSendMessage") }}</label>
        </div>

        <div class="times">
            <div class="time-box" :class="{ active: selection === 'now' }" @click="() => changeSelection('now')">
                {{ $t("wp.instantlyRightNow") }}
            </div>
            <!-- <a-divider>or</a-divider>
            <VueCtkDateTimePicker
                v-model="selectedDate"
                :min-date="new Date().toDateString()"
                button-color="#1890ff"
                :label="$t('wp.scheduleFuture')"
            >
                <div class="time-box" :class="{ active: selection === 'future' }" @click="() => changeSelection('now')">
                    {{ $t("wp.scheduleFuture") }}
                </div>
            </VueCtkDateTimePicker>-->

            <a-alert :message="getInfoMessage()" type="info" show-icon />
        </div>
    </div>
</template>

<script>
import moment from "moment";
import log2 from "../../../../../../utils/log2";
import Vue from "vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import _ from "lodash";
import { mapState } from "vuex";

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
const log = log2("TimeSelect");
export default {
    name: "TimeSelect",
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            whatsappPlusEnabled: (state) => _.get(state.setting.settings, "whatsapp.plus.enabled", false),
        }),
    },
    data() {
        return {
            selection: "now",
            selectedDate: null,
            renderCount: 0,
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        openNotificationWithIcon(featureType, type = "warning") {
            const messages = {
                scheduleFeature: {
                    message: "Whatsapp Plus Plan Required.",
                    description:
                        "Scheduling broadcast message feature is only available for Whatsapp Plus Plan. Please upgrade your plan to use this feature.",
                },
            };
            const message = messages[featureType];
            const key = `plan`;
            this.$notification[type]({
                message: message.message,
                description: message.description,
                placement: "topRight",
                key,
                btn: (h) => {
                    return h(
                        "a-button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    log("clicked", this.$notification);
                                    this.$router.push("/settings/billing");
                                    this.$notification.close(key);
                                },
                            },
                        },
                        "Change Plan"
                    );
                },
            });
        },
        getInfoMessage() {
            if (this.selection === "now") {
                return this.$t("wp.messageDesc");
            } else {
                return this.$t("wp.messageSendAt") + moment(this.selectedDate).format("MMMM Do YYYY, h:mm:ss a");
            }
        },
        changeSelection(newSelection) {
            log("changeSelection", newSelection);
            if (newSelection === "now") {
                this.selectedDate = null;
                this.clone.sendNow = true;
                this.clone.sendFutureAt = null;
            } else {
                // this.selectedDate = moment().add(1, "hour").toDate().toDateString();
                if (!this.whatsappPlusEnabled) {
                    this.openNotificationWithIcon("scheduleFeature");
                    this.selection = "now";
                    return;
                }
            }
            this.selection = newSelection;
            this.renderCount++;
        },
    },
    watch: {
        selectedDate(date) {
            if (date) {
                log("selectedDate changed", date);
                this.selectedDate = date;
                this.clone.sendNow = false;
                this.clone.sendFutureAt = date;
                if (this.selection !== "future") {
                    if (!this.whatsappPlusEnabled) {
                        this.openNotificationWithIcon("scheduleFeature");
                        this.changeSelection("now");
                        return;
                    }
                    this.changeSelection("future");
                }
            }
        },
        clone: {
            handler(newVal) {
                log("clone changed", newVal);
                this.$emit("input", newVal);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.time-select {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .header {
        display: flex;
        flex-direction: column;
        gap: 5px;
        color: #5a5f72;
        font-size: 16px;
        justify-content: center;
        align-items: center;
        margin: 5px;
    }

    .times {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        width: 400px;

        .vdatetime.time-box {
            padding: 0;

            input {
                cursor: pointer;
            }
        }

        .time-box {
            width: 100%;
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #e8e8e8;
            margin-bottom: 10px;
            cursor: pointer;

            &.active {
                background-color: #1890ff;
                color: white;
            }

            &:hover {
                border: 1px solid #1890ff;
            }
        }
    }
}
</style>
